import React, { useState } from "react";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { DialogProps } from "./DialogProps";
import { ICustomerAddress } from "../../Interfaces/Customer/ICustomerAddress";
import AddressCard from "../Views/OrderEditor/AddressCard";
import {hasValue} from "@amsanalytics/react-shared-library";

export interface AddressDialogProps extends DialogProps<ICustomerAddress> {
  address?: ICustomerAddress;
  applicantAddressStateIdsToFilterBy: string[]; // list of state ids to filter by
  applicationDate: Date;
}

export default function AddressDialog(props: AddressDialogProps) {
  const [address, setAddress] = useState<Partial<ICustomerAddress>>(props.address || {});
  const [errors, setErrors] = useState<Error[]>([]);
  const updateAddress = (address: Partial<ICustomerAddress>) => {
    if(errors.length > 0) validateAddress(address);
    setAddress({...address})
  };
  const validateAddress = (address: Partial<ICustomerAddress>): boolean => {
    const errors: Error[] = [];
    if(hasValue(address.street1) === false) {
      const error = new Error('Street is required');
      error.name = 'Street';
      errors.push(error);
    }
    if(hasValue(address.city) === false) {
      const error = new Error('City is required');
      error.name = 'City';
      errors.push(error);
    }
    if(hasValue(address.stateId) === false) {
      const error = new Error('State is required');
      error.name = 'State';
      errors.push(error);
    }
    if(hasValue(address.zipCode) === false) {
      const error = new Error('Zip is required');
      error.name = 'Zip';
      errors.push(error);
    }
    setErrors(errors);
    return errors.length === 0;
  };
  return (
    <>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Address
      </DialogTitle>
      <DialogContent>
        <AddressCard
          {...props}
          disabled={false}
          address={address as ICustomerAddress}
          onUpdateAddress={updateAddress}
          errors={errors}
          applicantAddressStateIdsToFilterBy={props.applicantAddressStateIdsToFilterBy}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={() => {
            if(validateAddress(address)) {
              (props.accept && props.accept(address as ICustomerAddress));
            }
          }}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}
